import { _ as _sfc_main, a as _sfc_main$1 } from "./BAccordionItem.vue_vue_type_script_setup_true_lang-BAMvJL5e.mjs";
import { B as BAlert } from "./BAlert-D1JaLQZ_.mjs";
import { _ as _sfc_main$2, a as _sfc_main$3 } from "./BAvatarGroup.vue_vue_type_script_setup_true_lang-D-cQG3Nv.mjs";
import { _ as _sfc_main$4 } from "./BBadge.vue_vue_type_script_setup_true_lang-Dv_mxsog.mjs";
import { _ as _sfc_main$5, a as _sfc_main$6 } from "./BBreadcrumb.vue_vue_type_script_setup_true_lang-BglGi00P.mjs";
import { _ as _sfc_main$7 } from "./BButton.vue_vue_type_script_setup_true_lang-ByjfGDl1.mjs";
import { _ as _sfc_main$8, a as _sfc_main$9 } from "./BButtonToolbar.vue_vue_type_script_setup_true_lang-kLRBwARi.mjs";
import { _ as _sfc_main$l } from "./BCloseButton.vue_vue_type_script_setup_true_lang-Dh0Odbqa.mjs";
import { _ as _sfc_main$a, a as _sfc_main$b, b as _sfc_main$c, c as _sfc_main$e, d as _sfc_main$f, e as _sfc_main$g, f as _sfc_main$i } from "./BCard.vue_vue_type_script_setup_true_lang-BMlJ-Sfo.mjs";
import { _ as _sfc_main$d, a as _sfc_main$h } from "./BCardText.vue_vue_type_script_setup_true_lang-wxG-S7oc.mjs";
import { _ as _sfc_main$j, a as _sfc_main$k } from "./BCarouselSlide.vue_vue_type_script_setup_true_lang-B9IWk30W.mjs";
import { _ as _sfc_main$n } from "./BCollapse.vue_vue_type_script_setup_true_lang-GJS1dKK5.mjs";
import { _ as _sfc_main$m } from "./BCol.vue_vue_type_script_setup_true_lang-D9P1sZki.mjs";
import { _ as _sfc_main$o } from "./BContainer.vue_vue_type_script_setup_true_lang-CgRJQB0l.mjs";
import { _ as _sfc_main$1f } from "./BRow.vue_vue_type_script_setup_true_lang-DMOOc6Rl.mjs";
import { B as BDropdown } from "./BDropdown-CmJPEOPT.mjs";
import { _ as _sfc_main$p, a as _sfc_main$q, b as _sfc_main$r, c as _sfc_main$s, d as _sfc_main$t, e as _sfc_main$u, f as _sfc_main$v } from "./BDropdownText.vue_vue_type_script_setup_true_lang-BbFXYMbV.mjs";
import { _ as _sfc_main$w } from "./BForm.vue_vue_type_script_setup_true_lang-PYY2WOtY.mjs";
import { _ as _sfc_main$z, a as _sfc_main$B } from "./BFormFloatingLabel.vue_vue_type_script_setup_true_lang-CqEz9Ydj.mjs";
import { _ as _sfc_main$E, a as _sfc_main$H, b as _sfc_main$O, c as _sfc_main$Q } from "./BFormValidFeedback.vue_vue_type_script_setup_true_lang-D2f9fSp7.mjs";
import { _ as _sfc_main$x, a as _sfc_main$y } from "./BFormCheckboxGroup.vue_vue_type_script_setup_true_lang-B5Msdqj3.mjs";
import { _ as _sfc_main$A } from "./BFormFile.vue_vue_type_script_setup_true_lang-C2z3iqJ-.mjs";
import { _ as _sfc_main$C } from "./BFormGroup.vue_vue_type_script_setup_true_lang-BfWpvBBH.mjs";
import { _ as _sfc_main$D } from "./BFormInput.vue_vue_type_script_setup_true_lang-DFp_G5MZ.mjs";
import { _ as _sfc_main$F, a as _sfc_main$G } from "./BFormRadioGroup.vue_vue_type_script_setup_true_lang-Bnc5FVv5.mjs";
import { _ as _sfc_main$I, a as _sfc_main$K } from "./BFormSelect.vue_vue_type_script_setup_true_lang-1z6NZtLV.mjs";
import { _ as _sfc_main$J } from "./useFormSelect-BrGF20vO.mjs";
import { _ as _sfc_main$L } from "./BFormSpinbutton.vue_vue_type_script_setup_true_lang-CNXr3MuF.mjs";
import { a as _sfc_main$M, _ as _sfc_main$N } from "./BFormTags.vue_vue_type_script_setup_true_lang-CtevLJ_Z.mjs";
import { _ as _sfc_main$P } from "./BFormTextarea.vue_vue_type_script_setup_true_lang-Dsl-lX8t.mjs";
import { _ as _sfc_main$R } from "./BImg.vue_vue_type_script_setup_true_lang-MMXD4NiQ.mjs";
import { _ as _sfc_main$S, a as _sfc_main$T } from "./BInputGroupText.vue_vue_type_script_setup_true_lang-BVvl0U34.mjs";
import { _ as _sfc_main$U } from "./BLink.vue_vue_type_script_setup_true_lang-CinzoAgQ.mjs";
import { _ as _sfc_main$V, a as _sfc_main$W } from "./BListGroupItem.vue_vue_type_script_setup_true_lang-DF5MpHVf.mjs";
import { B as BModal, _ as _sfc_main$X } from "./BModalOrchestrator.vue_vue_type_script_setup_true_lang-Vpb9dNna.mjs";
import { _ as _sfc_main$Y, a as _sfc_main$Z, b as _sfc_main$_, c as _sfc_main$$, d as _sfc_main$10 } from "./BNavText.vue_vue_type_script_setup_true_lang-CpHz539e.mjs";
import { _ as _sfc_main$11, a as _sfc_main$12, b as _sfc_main$13, c as _sfc_main$14 } from "./BNavbarToggle.vue_vue_type_script_setup_true_lang-Cr7xqOoW.mjs";
import { B as BOffcanvas } from "./BOffcanvas-BIRIpipC.mjs";
import { _ as _sfc_main$15 } from "./BOverlay.vue_vue_type_script_setup_true_lang-B7Rz8M_8.mjs";
import { _ as _sfc_main$16 } from "./BPagination.vue_vue_type_script_setup_true_lang-D_cnf8zg.mjs";
import { _ as _sfc_main$17, a as _sfc_main$18, b as _sfc_main$19, c as _sfc_main$1a, d as _sfc_main$1b } from "./BPlaceholderWrapper.vue_vue_type_script_setup_true_lang-DI0iHvHM.mjs";
import { B as BPopover } from "./floatingUi-DvHiyg2I.mjs";
import { _ as _sfc_main$1c } from "./BPopoverOrchestrator.vue_vue_type_script_setup_true_lang-CyJwKua6.mjs";
import { _ as _sfc_main$1d, a as _sfc_main$1e } from "./BProgress.vue_vue_type_script_setup_true_lang-csJop4n-.mjs";
import { _ as _sfc_main$1g } from "./BSpinner.vue_vue_type_script_setup_true_lang-CP3yvZKE.mjs";
import { _ as _sfc_main$1i, a as _sfc_main$1j, b as _sfc_main$1m, c as _sfc_main$1n, d as _sfc_main$1o, e as _sfc_main$1p, f as _sfc_main$1q, g as _sfc_main$1t } from "./BTable.vue_vue_type_script_setup_true_lang-s3mA7RWN.mjs";
import { _ as _sfc_main$1k } from "./BTableSimple.vue_vue_type_script_setup_true_lang-Dl-5AMhv.mjs";
import { _ as _sfc_main$1h, a as _sfc_main$1l } from "./BTabs.vue_vue_type_script_setup_true_lang-DamGvRZ4.mjs";
import { B as BToast, _ as _sfc_main$1r } from "./BToastOrchestrator.vue_vue_type_style_index_0_lang-Cne4Kadd.mjs";
import { _ as _sfc_main$1s } from "./BTooltip.vue_vue_type_script_setup_true_lang-B8VgPQS2.mjs";
const index = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  BAccordion: _sfc_main,
  BAccordionItem: _sfc_main$1,
  BAlert,
  BAvatar: _sfc_main$2,
  BAvatarGroup: _sfc_main$3,
  BBadge: _sfc_main$4,
  BBreadcrumb: _sfc_main$5,
  BBreadcrumbItem: _sfc_main$6,
  BButton: _sfc_main$7,
  BButtonGroup: _sfc_main$8,
  BButtonToolbar: _sfc_main$9,
  BCard: _sfc_main$a,
  BCardBody: _sfc_main$b,
  BCardFooter: _sfc_main$c,
  BCardGroup: _sfc_main$d,
  BCardHeader: _sfc_main$e,
  BCardImg: _sfc_main$f,
  BCardSubtitle: _sfc_main$g,
  BCardText: _sfc_main$h,
  BCardTitle: _sfc_main$i,
  BCarousel: _sfc_main$j,
  BCarouselSlide: _sfc_main$k,
  BCloseButton: _sfc_main$l,
  BCol: _sfc_main$m,
  BCollapse: _sfc_main$n,
  BContainer: _sfc_main$o,
  BDropdown,
  BDropdownDivider: _sfc_main$p,
  BDropdownForm: _sfc_main$q,
  BDropdownGroup: _sfc_main$r,
  BDropdownHeader: _sfc_main$s,
  BDropdownItem: _sfc_main$t,
  BDropdownItemButton: _sfc_main$u,
  BDropdownText: _sfc_main$v,
  BForm: _sfc_main$w,
  BFormCheckbox: _sfc_main$x,
  BFormCheckboxGroup: _sfc_main$y,
  BFormDatalist: _sfc_main$z,
  BFormFile: _sfc_main$A,
  BFormFloatingLabel: _sfc_main$B,
  BFormGroup: _sfc_main$C,
  BFormInput: _sfc_main$D,
  BFormInvalidFeedback: _sfc_main$E,
  BFormRadio: _sfc_main$F,
  BFormRadioGroup: _sfc_main$G,
  BFormRow: _sfc_main$H,
  BFormSelect: _sfc_main$I,
  BFormSelectOption: _sfc_main$J,
  BFormSelectOptionGroup: _sfc_main$K,
  BFormSpinbutton: _sfc_main$L,
  BFormTag: _sfc_main$M,
  BFormTags: _sfc_main$N,
  BFormText: _sfc_main$O,
  BFormTextarea: _sfc_main$P,
  BFormValidFeedback: _sfc_main$Q,
  BImg: _sfc_main$R,
  BInput: _sfc_main$D,
  BInputGroup: _sfc_main$S,
  BInputGroupText: _sfc_main$T,
  BLink: _sfc_main$U,
  BListGroup: _sfc_main$V,
  BListGroupItem: _sfc_main$W,
  BModal,
  BModalOrchestrator: _sfc_main$X,
  BNav: _sfc_main$Y,
  BNavForm: _sfc_main$Z,
  BNavItem: _sfc_main$_,
  BNavItemDropdown: _sfc_main$$,
  BNavText: _sfc_main$10,
  BNavbar: _sfc_main$11,
  BNavbarBrand: _sfc_main$12,
  BNavbarNav: _sfc_main$13,
  BNavbarToggle: _sfc_main$14,
  BOffcanvas,
  BOverlay: _sfc_main$15,
  BPagination: _sfc_main$16,
  BPlaceholder: _sfc_main$17,
  BPlaceholderButton: _sfc_main$18,
  BPlaceholderCard: _sfc_main$19,
  BPlaceholderTable: _sfc_main$1a,
  BPlaceholderWrapper: _sfc_main$1b,
  BPopover,
  BPopoverOrchestrator: _sfc_main$1c,
  BProgress: _sfc_main$1d,
  BProgressBar: _sfc_main$1e,
  BRow: _sfc_main$1f,
  BSpinner: _sfc_main$1g,
  BTab: _sfc_main$1h,
  BTable: _sfc_main$1i,
  BTableLite: _sfc_main$1j,
  BTableSimple: _sfc_main$1k,
  BTabs: _sfc_main$1l,
  BTbody: _sfc_main$1m,
  BTd: _sfc_main$1n,
  BTfoot: _sfc_main$1o,
  BTh: _sfc_main$1p,
  BThead: _sfc_main$1q,
  BToast,
  BToastOrchestrator: _sfc_main$1r,
  BTooltip: _sfc_main$1s,
  BTr: _sfc_main$1t
}, Symbol.toStringTag, { value: "Module" }));
export {
  index as i
};
//# sourceMappingURL=index-9guXRVSw.mjs.map
